import React from "react";
import ListElement from "../../common/components/ListElement";
import { PALETTE } from "../../common/ThemeConstants";
import Logo from "../../common/images/logoFree.png";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import {
  FaInstagram,
  FaFacebookSquare,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

export default function HomeFooter({ isLogged, categories }) {
  let marginLogo = "";
  let alignmentClass = "text-start";

  return (
    <footer
      id="footer"
      className="justify-content-center px-3 pt-3 bg-dark"
      style={{ color: PALETTE.LIGHTGRAY }}
    >
      <Container>
        <Row>
          <Col
            md={3}
            className={alignmentClass}
            style={{ marginBottom: "2rem" }}
          >
            <a href={"/#cover"} className={alignmentClass}>
              <img
                className={`d-block ${marginLogo}`}
                width={120}
                src={Logo}
                alt="Federico Bartoli PT"
              ></img>
            </a>
            <div style={{ color: PALETTE.KINDALIGHTGRAY }}>
              {" "}
              <span style={{ fontWeight: "bold" }}>Federico Bartoli PT</span>
              <br />
              <span>&copy; 2022 All Rights Reserved</span>
            </div>
            <div>
              <p
                className="text-start"
                style={{ color: PALETTE.TRUEGRAY, fontSize: 10 }}
              >
                Powered by{" "}
                <a
                  href="https://simo6.github.io/"
                  style={{ textDecoration: "none", fontWeight: "bold" }}
                >
                  Simone Bartoli
                </a>
              </p>
            </div>
          </Col>
          <Col
            md={3}
            className={alignmentClass}
            style={{ marginBottom: "2rem" }}
          >
            <p className="pt-1" style={{ fontSize: "18px" }}>
              CONTATTI
            </p>
            <hr />
            <ListElement
              IconHeader={
                <FaMapMarkerAlt color={PALETTE.LIGHTGRAY} size={20} />
              }
              description={"Via Flaminia, 129, 61041 Acqualagna PU"}
              url={"https://goo.gl/maps/y38ZzBexP2BCp7vH8"}
            />
            <ListElement
              IconHeader={<FaPhoneAlt color={PALETTE.LIGHTGRAY} size={20} />}
              description={"+39 3487264071"}
            />
            <ListElement
              IconHeader={<FaInstagram color={PALETTE.LIGHTGRAY} size={20} />}
              description={"@federico_bartoli_pt"}
              url={"https://www.instagram.com/federico_bartoli_pt/?hl=it"}
            />
            <ListElement
              IconHeader={
                <FaFacebookSquare color={PALETTE.LIGHTGRAY} size={20} />
              }
              description={"FedericoBartoliPT"}
              url={"https://www.facebook.com/FedericoBartoliPT?locale=it_IT"}
            />
          </Col>
          <Col
            md={3}
            className={alignmentClass}
            style={{ marginBottom: "2rem" }}
          >
            <p className="pt-1" style={{ fontSize: "18px" }}>
              CONTENUTI
            </p>
            <hr />
            <ListElement
              alignmentClass={alignmentClass}
              description={"Profilo"}
              url={isLogged ? "/account/Profile/Skills/" : "/login"}
            />
            <ListElement
              alignmentClass={alignmentClass}
              description={"Allenamenti"}
              url={isLogged ? "/account/Workouts/Workout/" : "/login"}
            />
            <ListElement
              alignmentClass={alignmentClass}
              description={"Esercizi"}
              url={isLogged ? "/account/Exercises/" : "/login"}
            />
            <ListElement
              alignmentClass={alignmentClass}
              description={"Account"}
              url={isLogged ? "/account/Account/" : "/login"}
            />
          </Col>
          <Col md={3} style={{ marginBottom: "2rem" }}>
            <p className="pt-1" style={{ fontSize: "18px" }}>
              LEGAL
            </p>
            <hr />
            <ListElement
              alignmentClass={alignmentClass}
              description={"Informativa sulla privacy"}
              url={"/PrivacyPolicy"}
            />
            <ListElement
              alignmentClass={alignmentClass}
              description={"Termini di servizio"}
              url={"/TermsOfService"}
            />
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
